import type { FlagData } from "./types";

let cachedData: FlagData | null = null;
let fetchPromise: Promise<void> | null = null;
let listeners: Array<() => void> = [];

function notifyListeners() {
  listeners.forEach((fn) => { fn(); });
}

export function getCachedData(): FlagData | null {
  return cachedData;
}

export function subscribe(listener: () => void): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((fn) => fn !== listener);
  };
}

export function fetchFlags(force = false): Promise<void> {
  if (fetchPromise && !force) return fetchPromise;
  fetchPromise = fetch("/dev_tools/feature-flags", {
    cache: "no-store",
  })
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then((json) => {
      cachedData = json;
      notifyListeners();
    })
    .catch((e) => {
      console.error("Feature flags fetch error:", e);
    })
    .finally(() => {
      fetchPromise = null;
    });
  return fetchPromise;
}

function csrfToken(): string {
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") || ""
  );
}

export function submitForm(action: string, fields: Record<string, string>) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  form.style.display = "none";

  const allFields = {
    authenticity_token: csrfToken(),
    return_to: window.location.href,
    ...fields,
  };

  Object.entries(allFields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
